export class Breadcrumb {
  public title: string;
  public targetUrl: string;
  public fragment: string | undefined;
  public active: boolean = false;
  public disabled: boolean = false;

  constructor(title: string, targetUrl: string, active: boolean = false, fragment?: string) {
    this.title = title;
    this.targetUrl = targetUrl;
    this.active = active;
    this.fragment = fragment;
  }
}
